.dialog {
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  padding: 1.5rem;
  max-width: 32rem;
  width: calc(100% - 2rem);
  background: var(--card);
  color: var(--ink);
  box-shadow: var(--shadow-soft);
}

.dialog::backdrop {
  background: color-mix(in srgb, var(--ink) 45%, transparent);
}

.title {
  font-family: var(--font-display);
  margin: 0 0 1rem;
}
